import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach the SQL token to the RMS API, never unrelated destinations.
  const api = environment.WS_URL.replace(/\/$/, '') + '/api/v1/';
  if (!req.url.startsWith(api)) return next(req);
  const auth = inject(AuthService);
  return from(auth.getSqlAccessToken()).pipe(
    switchMap(token => next(req.clone({setHeaders:{Authorization: `Bearer ${token}`}})).pipe(
      catchError(error => {
        // A forbidden action (403) does not mean the Microsoft session ended.
        if (error.status === 401 && localStorage.getItem('ms_authToken') === token) auth.logout();
        return throwError(() => error);
      })
    ))
  );
};
